import React from 'react'
import NormalLayoutContainer from '../shared/NormalLayoutContainer'
import { Spinner } from '../shared/Spinner'
import useEditTermsAndConditionAgreement from './useEditTermsAndConditionAgreement'
import EditTermsAndConditionAgreementForm from './EditTermsAndConditionAgreementForm'

export default function EditTermsAndConditionAgreementPage () {
  const {
    agreement,
    isFetching,
    isError,
    initialValues,
    isDraft,
    agreementStatus,
    isDirtyRef,
    isSaving,
    isDeleting,
    isTogglingStatus,
    saveAgreement,
    handleStatusChange,
    destroyAgreement,
    handleBackClick
  } = useEditTermsAndConditionAgreement()

  if (isFetching && !agreement) {
    return (
      <NormalLayoutContainer showBackLink>
        <Spinner isFetching />
      </NormalLayoutContainer>
    )
  }

  if (isError && !agreement) {
    return (
      <NormalLayoutContainer showBackLink>
        <h4 className='text-center'>Unable to load T&C agreement</h4>
      </NormalLayoutContainer>
    )
  }

  if (!agreement) {
    return (
      <NormalLayoutContainer showBackLink>
        <h4 className='text-center'>Agreement not found</h4>
      </NormalLayoutContainer>
    )
  }

  return (
    <NormalLayoutContainer showBackLink onBackClick={handleBackClick}>
      <EditTermsAndConditionAgreementForm
        initialValues={initialValues}
        isDraft={isDraft}
        agreementStatus={agreementStatus}
        isDirtyRef={isDirtyRef}
        isSaving={isSaving}
        isDeleting={isDeleting}
        isTogglingStatus={isTogglingStatus}
        onSave={saveAgreement}
        onStatusChange={handleStatusChange}
        onDestroy={destroyAgreement}
      />
    </NormalLayoutContainer>
  )
}
